var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"fill-height":"","column":""}},[_c('div',[_c('v-img',{attrs:{"contain":"","src":require('@/assets/images/phonics/top-4.png')}})],1),_c('v-container',{staticClass:"template-padding"},_vm._l((_vm.items),function(item,itemIndex){return _c('div',{key:itemIndex},[(item.type == 'banner')?[_c('v-container',{class:_vm.outerContainer},[_c('div',{staticClass:"rubik font-weight-bold title-header",class:_vm.$vuetify.breakpoint.xsOnly ? 'h5 text-left' : 'h4',attrs:{"contenteditable":_vm.editableContent},domProps:{"innerHTML":_vm._s(item.text)},on:{"focusout":function($event){return _vm.editableData('banner', { element: 'text' })}}}),(_vm.pageType == 'Canvas')?_c('RowControls',{attrs:{"rowIndex":itemIndex}}):_vm._e()],1)]:_vm._e(),(item.type == 'grids')?[_c('Grid2',{attrs:{"item":item,"index":itemIndex,"styles":{
                            text: 'rubik',
                            image: {
								contain: true,
								wrapper: '',
								class: '',
								height: 'auto',
								width: 'auto',
								maxWidth: '100%',
								maxHeight: '',
								custom: {
									margin: '0 auto'
								}
							},
                            heading1: {
                                wrapper: 'mb-5',
                                classMobile: 'h5 ph4-heading rubik font-weight-bold',
                                classLarge: 'h5 ph4-heading rubik font-weight-bold',
                                after: '',
								guideWrapper: '',
								guideClass: 'ml-5'
                            },
                            heading2: {
                                wrapper: 'mb-5',
                                classMobile: 'h5 ph4-heading rubik font-weight-bold',
                                classLarge: 'h5 ph4-heading rubik font-weight-bold',
                                after: '',
								guideWrapper: '',
								guideClass: 'ml-5'
                            },
                            textcard: {
                                outlined: true,
                                elevation: 0,
                                card: 'mb-5 ph4-outlined-card',
                                text: 'text-uppercase h5 rubik font-weight-bold py-3 text-center',
                                subtitle: ''
                            },
                            imagecard: {
                                settings: {
                                    colsImage: '',
                                    colsText: ''
                                },
                                doubleCard: {
                                    status: false,
                                    inner: ''
                                },
                                elevation: 1,
                                outlined: false,
                                card: 'ph4-bordered-card mb-3 py-3',
                                imagePosition: 'bottom',
                                image: {
                                    height: '65px',
                                    width: '65px'
                                },
                                text: 'text-center h5 font-weight-bold poppins mb-1',
                                subtitle: '',
                            },

                            dialog: {
								elevation: '',
								cardClass: 'py-5 px-5 my-5',
								cardColor: '#1faefb',
								innerCard: '',
								dialogTitle: 'h5 mb-5',
								textWrapper: 'body poppins text-left',
								dialogName: 'rubik font-weight-bold mr-2',
								custom: {
									text: ''
								}
							}
                        }}})]:_vm._e()],2)}),0),_c('div',{staticClass:"mt-10"},[_c('v-img',{attrs:{"contain":"","src":require('@/assets/images/phonics/bottom-4.png')}})],1),_c('ImageUploader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }